import gql from 'graphql-tag'

export const CONTRACT_FILE_CREATE_MUTATION = gql`
    mutation contractFileCreate(
        $contractId: ID!
        $typeId: ID!
        $file: Upload!
    ) {
        contractFileCreate(
            contract_id: $contractId
            type_id: $typeId
            file: $file
        ) {
            id
            file {
                id
                name
            }
            type {
                id
                status
                key
                name
            }
            consultant {
                id
                contact_number
                first_name
                last_name
                gender
                title
                consulting_company_name
                consulting_settings_status
            }
        }
    }
`
